import React, { useRef, useState } from "react";
import {
  PlayerWrapper,
  ControlsRowV1,
  PlayButton,
  ProgressWrapper,
  ProgressBar,
  VolumeProgressBar,
} from "./style";
import PropTypes from "prop-types";
import { PauseButtonIcon, PlayButtonIcon, VolumeIcon } from "../../../utils/icons";

const AudioPlayerV2 = ({ src,margin , onComplete,   showListenText = true,  showVolume = true, displayNone = false}) => {
  const audioRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [hasError, setHasError] = useState(false);
  const [volume, setVolume] = useState(1); // 0 → 1

  const togglePlay = async () => {
    const audio = audioRef.current;
    if (!audio || hasError) return;

    try {
      if (isPlaying) {
        audio.pause();
        setIsPlaying(false);
      } else {
        await audio.play(); // 🔥 may fail
        setIsPlaying(true);
      }
    } catch (err) {
      window.console.error("Audio play failed:", err);
      setHasError(true);
      setIsPlaying(false);
    }
  };

  const handleTimeUpdate = () => {
    const audio = audioRef.current;
    if (!audio || isNaN(audio.duration)) return;

    setCurrentTime(audio.currentTime);
    setDuration(audio.duration);
  };

  const handleSeek = (e) => {
    const audio = audioRef.current;
    if (!audio || hasError) return;

    const value = Number(e.target.value);
    audio.currentTime = value;
    setCurrentTime(value);
  };

  const handleError = () => {
    setHasError(true);
    setIsPlaying(false);
    setCurrentTime(0);
    setDuration(0);
  };

  const formatTime = (t) =>
    isNaN(t) || t === Infinity
      ? "0:00"
      : `${Math.floor(t / 60)}:${("0" + Math.floor(t % 60)).slice(-2)}`;

  const handleEnded = () => {
    const audio = audioRef.current;
    if (!audio) return;
  
    audio.pause();
    audio.currentTime = 0;
  
    setIsPlaying(false);
    setCurrentTime(0);

    if (onComplete) {
      onComplete(); // ✅ trigger modal
    }
  };

  const handleVolumeChange = (e) => {
    const audio = audioRef.current;
    if (!audio) return;
  
    const value = Number(e.target.value);
    audio.volume = value;
    setVolume(value);
  };

  const getSliderBackground = (value, max) => {
    const percent = max ? (value / max) * 100 : 0;
    return `linear-gradient(
      to right,
      #DA6C74 0%,
      #DA6C74 ${percent}%,
      #ddd ${percent}%,
      #ddd 100%
    )`;
  };

  return (
    <PlayerWrapper data-disabled={hasError} margin={margin}>
      <PlayButton  displayNone={displayNone} style={{ opacity: hasError ? 0.5 : 1, pointerEvents: hasError ? "none" : "auto" }}>
        {!showListenText ? null : <div className="first-row">
          <div className="listen-text" >
            Listen to Article
          </div>

        </div>}  

        <div className={!displayNone ? "normal-row" : " first-row"}>
          <div
            className="play-button"
            onClick={togglePlay}
          
          >
            {isPlaying ? PauseButtonIcon() : PlayButtonIcon()}
          </div>

          {/* <div className="play-time">{formatTime(currentTime)}</div> */}
        </div>

        {showVolume && ( <div className="first-row">
          <div className="volume-icon">{VolumeIcon()}</div>
          <VolumeProgressBar
            style={{ background: getSliderBackground(volume, 1),opacity: hasError ? 0.5 : 1, pointerEvents: hasError ? "none" : "auto" }}
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={volume}
            onChange={handleVolumeChange}
            // disabled={hasError}
          />
        </div>
        )}
      </PlayButton>

      <ControlsRowV1>
        {/* <div className="play-time">{formatTime(currentTime)}</div> */}
        <ProgressWrapper>
          <ProgressBar
            type="range"
            min="0"
            style={{ background: getSliderBackground(currentTime, duration),opacity: hasError ? 0.5 : 1, pointerEvents: hasError ? "none" : "auto" }}
            max={duration || 0}
            value={currentTime}
            onChange={handleSeek}
            disabled={hasError}
          />
        </ProgressWrapper>
        <div className="time-row">
          <div className="play-time">{formatTime(currentTime)}</div>
          <div className="total-time">{formatTime(duration)}</div>
        </div>
        {/* <div className="total-time">{formatTime(duration)}</div> */}
      </ControlsRowV1>

      <audio
        ref={audioRef}
        src={src}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleTimeUpdate}
        onError={handleError}
        preload="metadata"
        onEnded={handleEnded} 
      />
    </PlayerWrapper>
  );
};

AudioPlayerV2.propTypes = {
  src: PropTypes.string,
  margin:PropTypes.string,
  onComplete: PropTypes.func, 
  showListenText: PropTypes.bool,
  showVolume: PropTypes.bool,
  displayNone: PropTypes.bool,
};

export default AudioPlayerV2;
